"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTestHistory = exports.createHistory = void 0;
var __1 = require("../..");
var history_1 = require("history");
var createHistory = function (type, navBlocker, basename) {
    var unblock = function () { return null; }; // default value to begin with
    var createFn = type === 'memory' ? history_1.createMemoryHistory : history_1.createBrowserHistory;
    var history = createFn({
        getUserConfirmation: function (_, callback) {
            navBlocker.setBlockReleaser(callback);
            navBlocker.reportBlocked();
        },
        basename: basename
    });
    navBlocker.addListener(function (_a) {
        var isBlocked = _a.isBlocked;
        if (isBlocked) {
            var dummyMsg = 'needed so get user confirmation gets called';
            unblock = history.block(dummyMsg);
        }
        else {
            unblock();
        }
    });
    return history;
};
exports.createHistory = createHistory;
var createTestHistory = function () {
    return (0, exports.createHistory)('memory', (0, __1.createNavBlocker)(), '');
};
exports.createTestHistory = createTestHistory;
//# sourceMappingURL=index.js.map